import { capitalize } from '../../../../../services/utils'

export const formatUserType = (type: API.Role) : string => {
  if (type === 'superadmin') {
    return 'Super Admin'
  }
  return capitalize(type)
}